export class GlobalConstants {
    public static applicationId = "e35ce046-236e-4c12-985e-9d23cbfec6b7";
    public static scheduleApplicationId = "8c55a16f-9d69-438b-a29c-d8267227f427"
}